import { useState, useEffect } from 'react';

interface SplashScreenProps {
  onComplete: () => void;
}

export const SplashScreen = ({ onComplete }: SplashScreenProps) => {
  const [isExiting, setIsExiting] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsExiting(true);
      setTimeout(onComplete, 1500);
    }, 2000);

    return () => clearTimeout(timer);
  }, [onComplete]);

  return (
    <div className={`min-h-screen flex items-center justify-center bg-white ${isExiting ? 'animate-fade-out' : ''}`}>
      <img
        src="https://app.thenewscc.com.br/logo.png"
        alt="Waffle Logo"
        className="h-12 w-auto"
      />
    </div>
  );
}; 